import script from "./EmptyTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyTable.vue?vue&type=script&setup=true&lang=js"

import "./EmptyTable.vue?vue&type=style&index=0&id=004338aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-004338aa"]])

export default __exports__